"use client";

import React, { useEffect, useState } from "react";
import "./Left_Tabs.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";

import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

// import Logout_Modal from "../../common-components/common_modal/logout_modal/Logout_Modal";

const Left_Tabs = (props) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const router = useNavigate();

  // const [activeTab, setActiveTab] = useState(0);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("my_account_active_tab");

    const tabLabels = [
      "Profile",
      "Order",
      "Order History",
      "Cancelled Orders",
      "Wallet",
      "Appointment History",
    ];

    const index = tabLabels.indexOf(savedTab);

    return index >= 0 ? index : 0;
  });
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [expandedTabIndex, setExpandedTabIndex] = useState(null);

  const mobile_tabs = [
    {
      tab_label: "Profile",
    },
    {
      tab_label: "Order",
    },
    {
      tab_label: "Order History",
    },
    {
      tab_label: "Cancelled Orders",
    },
    {
      tab_label: "Wallet",
    },
    {
      tab_label: "Appointment History",
    },
  ];

  const tabs = [
    {
      tab_label: "Profile",
    },
    {
      tab_label: "Order",
    },
    {
      tab_label: "Order History",
    },
    {
      tab_label: "Cancelled Orders",
    },
    {
      tab_label: "Wallet",
    },
    {
      tab_label: "Appointment History",
    },
  ];

  useEffect(() => {
    const creditsTab = tabs.find((tab) => tab.tab_label === "MY ORDERS");

    const index = tabs.findIndex((tab) => tab.tab_label === "MY ORDERS");

    if (activeTab === index && creditsTab?.subTabs?.length > 0) {
      if (!activeSubTab || !creditsTab.subTabs.includes(activeSubTab)) {
        const defaultSubTab = creditsTab.subTabs[0];

        setActiveSubTab(defaultSubTab);
        props?.setSelectedTab(defaultSubTab);
      }
    }
  }, [activeTab, activeSubTab, props, tabs]);

  const toggleExpand = (index) => {
    setExpandedTabIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="Left_Tabs">
      {/* Desktop Sidebar */}
      <div className="desktop_sidebar">
        {tabs.map((item, index) => {
          const isMainActive = activeTab === index;
          const hasSubTabs = item.subTabs?.length > 0;
          const isExpanded = expandedTabIndex === index;

          return (
            <React.Fragment key={index}>
              <div
                className={`tabs_main_div ${
                  isMainActive ? "active red_bg_div" : "blue_bg_div"
                }`}
                onClick={() => {
                  if (item?.tab_label === "LOGOUT") {
                    setShowLogoutModal(true);
                    return;
                  }

                  if (!hasSubTabs) {
                    setActiveTab(index);
                    setActiveSubTab(null);

                    props?.setSelectedTab(item?.tab_label);

                    setExpandedTabIndex(null);
                  } else {
                    setActiveTab(index);

                    if (expandedTabIndex === index) {
                      return;
                    } else {
                      setExpandedTabIndex(index);
                    }
                  }
                }}
              >
                <div className="text_holder">
                  <p className="tab_name">{item?.tab_label}</p>

                  {hasSubTabs && (
                    <span className="icon">
                      {isExpanded ? (
                        <FontAwesomeIcon icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon icon={faAngleDown} />
                      )}
                    </span>
                  )}
                </div>
              </div>

              {isMainActive && hasSubTabs && (
                <div className="inner_tabs">
                  {item.subTabs.map((subTab, subIndex) => (
                    <div
                      key={subIndex}
                      className={`inner_tab ${
                        activeSubTab === subTab
                          ? "active-sub-tab"
                          : "blue_bg_div"
                      }`}
                      onClick={() => {
                        setActiveSubTab(subTab);

                        props?.setSelectedTab(subTab);
                      }}
                    >
                      {subTab}
                    </div>
                  ))}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Mobile Dropdown */}

      <div className="mobile_div">
        <div className="mobile_tabs_scroll">
          {mobile_tabs.map((value, index) => {
            const isMainActive = activeTab === index;

            return (
              <div
                key={index}
                className={`mobile_tab_item ${isMainActive ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(index);
                  setActiveSubTab(null);
                  setExpandedTabIndex(null);
                  props?.setSelectedTab(value?.tab_label);
                }}
              >
                <span className="mobile_tab_label">{value?.tab_label}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* old */}
      {/* <div className="mobile_div">
        <Dropdown>
          <Dropdown.Toggle
            className="tabs_main_div active dropdown_button"
            id="tab-dropdown"
          >
            <div className="text_holder">
              <p className="tab_name">
                {mobile_tabs[activeTab]?.tab_label || "Select Tab"}
              </p>
            </div>
            <span className="dropdown_arrow">
              <FontAwesomeIcon icon={faChevronDown}/>
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {mobile_tabs.map((value, index) => {
              const isMainActive = activeTab === index;

              return (
                <Dropdown.Item key={index} as="div">
                  <div
                    className={`tabs_main_div ${
                      isMainActive ? "active red_bg_div" : "blue_bg_div"
                    }`}
                    onClick={() => {
                      if (value?.tab_label === "LOGOUT") {
                        setShowLogoutModal(true);
                        return;
                      }

                      setActiveTab(index);

                      props?.setSelectedTab(value?.tab_label);
                    }}
                  >
                    <div className="text_holder">
                      <p className="tab_name">{value?.tab_label}</p>
                    </div>
                  </div>
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div> */}

      {/* Logout Modal */}
      {/* <Logout_Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
      /> */}
    </section>
  );
};

export default Left_Tabs;
